import { Suspense } from 'react';
import { renderRoutes } from 'react-router-config';
import { useWindowSize } from 'react-use';

import type { RouteConfigComponentProps } from 'react-router-config';

const App = ({ route }: RouteConfigComponentProps) => {
    const { width, height } = useWindowSize();

    return (
        <div style={{ width, height, overflow: 'hidden', overscrollBehavior: 'none' }}>
            <Suspense fallback={<></>}>
                {/* child routes won't render without this */}
                {renderRoutes(route && route.routes)}
            </Suspense>
        </div>
    );
};
export default App;
